import React, { useContext } from 'react'

import AppContext from './AppContext'
import CurrencyFormat from 'react-currency-format'

const TaxItem = ({ name, amount, currency }) => {
  const myContext = useContext(AppContext)

  return (
    <div className="flex flex-row justify-between font-bold font-mono">
      <div className="w-1/3"></div>
      <div className="w-1/6"></div>
      <div className="w-1/6 text-right">{name}</div>
      <div className="w-1/6 text-right">
        <CurrencyFormat
          value={amount}
          displayType={'text'}
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale={true}
          prefix={currency || myContext.currency}
        />
      </div>
    </div>
  )
}

export default TaxItem
